import { GlobalContext } from "Global/Base/GlobalContext";
import { createElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";

export class Nyan {
    private _cat: HTMLElement;
    private _catContainer: HTMLElement;
    private _audioFrame: HTMLAudioElement;
    private _wavesElemens: HTMLElement[] = [];

    private _framesAmount: number = 6;
    private _currentFrame: number = 1;

    public static start(lengthInSec: number = 3): void {
        const nc = new Nyan();
        nc.start(lengthInSec);
    }

    private _createElement(): Promise<void> {
        return new Promise<void>((res, err) => {
            this._createCatBody();

            const container = createElement({ id: "nyan-cat-container" });

            let wave = createElement({ id: "wave-a", classes: "hot rainbow" });
            this._wavesElemens.push(wave);
            container.appendChild(wave);

            wave = createElement({ id: "wave-a", classes: "cold rainbow" });
            this._wavesElemens.push(wave);
            container.appendChild(wave);

            wave = createElement({ id: "wave-b", classes: "hot rainbow" });
            this._wavesElemens.push(wave);
            container.appendChild(wave);

            wave = createElement({ id: "wave-b", classes: "cold rainbow" });
            this._wavesElemens.push(wave);
            container.appendChild(wave);

            this._audioFrame = createElement({
                type: "audio",
                id: "nyan-sound",
                attrs: { loop: "true", src: "sounds/ee/nyan.ogg" },
            }) as HTMLAudioElement;

            this._audioFrame.addEventListener("canplay", () => {
                res();
            });

            this._audioFrame.addEventListener("error", () => {
                err();
            });

            container.appendChild(this._cat);
            container.appendChild(this._audioFrame);
            document.body.appendChild(container);
            this._catContainer = container;
        });
    }

    private _createCatBody(): void {
        this._cat = createElement({ id: "nyan-cat", classes: "frame1" });

        const cat_tart = createElement({ id: "pop-tarts-body" });
        cat_tart.appendChild(createElement({ id: "pop-tarts-body-cream" }));

        const head = createElement({ id: "head" });
        head.appendChild(createElement({ id: "face" }));

        this._cat.appendChild(createElement({ id: "tail" }));
        this._cat.appendChild(createElement({ id: "paws" }));
        this._cat.appendChild(cat_tart);
        this._cat.appendChild(head);
    }

    private _cycleFrames(): void {
        this._cat.classList.remove(`frame${this._currentFrame}`);
        this._cat.classList.add(`frame${this._cycleIds(this._currentFrame)}`);
        this._currentFrame = this._cycleIds(this._currentFrame);
    }

    private _cycleIds(_currId: number): number {
        if (_currId >= this._framesAmount) {
            _currId = 1;
        } else {
            _currId += 1;
        }

        return _currId;
    }

    public async start(lengthInSec: number = 3): Promise<void> {
        try {
            await this._createElement();
        } catch (e) {
            this._catContainer.remove();
            return;
        }
        this._audioFrame.play();

        let rainbowLeft = 0;
        let catLeft = 0;

        const oneCycleLength = Math.ceil((lengthInSec * 1000) / 100);
        const fullwidth = window.innerWidth;
        const oneCycleLeft = fullwidth / 100;

        const timer = self.setInterval(() => {
            this._cycleFrames();
        }, 70);

        let count = 0;
        let fullTimer = self.setInterval(() => {
            rainbowLeft += oneCycleLeft;
            catLeft += oneCycleLeft;

            this._cat.style.left = catLeft + "px";

            for (const r of this._wavesElemens) {
                r.style.width = rainbowLeft + "px";
            }

            if (count >= 110) {
                //clearInterval(timer);
                clearInterval(fullTimer);
                //this.audioFrame.pause();
                //this.catContainer.remove();
                count = 0;
                rainbowLeft = 0;

                fullTimer = self.setInterval(() => {
                    rainbowLeft += oneCycleLeft;

                    for (const r of this._wavesElemens) {
                        r.style.left = rainbowLeft + "px";
                    }

                    if (count >= 100) {
                        clearInterval(timer);
                        clearInterval(fullTimer);
                        this._audioFrame.pause();
                        this._catContainer.remove();
                    }
                    count++;
                }, oneCycleLength);
            }
            count++;
        }, oneCycleLength);
    }

    public static startOther(type: string): void {
        if (type.toLowerCase() == "epicsax") {
            EpicSax.start();
        }
    }
}

class EpicSax {
    private _imgElement: HTMLImageElement;
    private _contentElement: HTMLDivElement;
    private _audioFrame: HTMLAudioElement;

    private _createElement(): void {
        this._contentElement = createElement({ classes: "epic-sax" }) as HTMLDivElement;
        this._imgElement = createElement({ type: "img", attrs: { src: "img/ee/esg.gif" } }) as HTMLImageElement;
        this._audioFrame = createElement({
            type: "audio",
            id: "nyan-sound",
            attrs: { src: "sounds/ee/esg.ogg" },
        }) as HTMLAudioElement;

        this._contentElement.appendChild(this._imgElement);
        this._contentElement.appendChild(this._audioFrame);
    }

    public async start(): Promise<void> {
        try {
            await this._createElement();
        } catch (e) {
            this._contentElement.remove();
            return;
        }
        this._audioFrame.play();

        document.body.appendChild(this._contentElement);
        this._contentElement.classList.add("start");

        const int = self.setInterval(() => {
            this._contentElement.classList.toggle("left");
        }, 1500);

        self.setInterval(() => {
            clearInterval(int);
            this._contentElement.remove();
        }, 13000);
    }

    public static start(): void {
        const d = new EpicSax();
        d.start();
    }
}

GlobalContext.register("EasterEgg", {
    epicSaxGuy: new EpicSax(),
    nyanCat: new Nyan(),
});
